"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useTotalPriceStyle = () => {
    const theme = (0, material_1.useTheme)();
    const container = {
        width: '%100',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: 'transparent',
    };
    const priceStyle = ({ item }) => {
        return Object.assign(Object.assign({ fontWeight: '400' }, theme.qlub.typography.body_sm), { color: theme.qlub.palette.onSurfaceColors.mediumEmphasis, position: 'relative', padding: '0 0 2px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', '&>span': {
                position: 'absolute',
                insetInlineEnd: '0',
                color: item.label === 'qlubDiscount' || item.label === 'fullyPaid'
                    ? theme.qlub.palette.success.main
                    : 'inherit',
            }, '&:last-of-type': Object.assign({ color: theme.qlub.palette.onSurfaceColors.highEmphasis }, theme.qlub.typography.title_md) });
    };
    const taxStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.mediumEmphasis, display: 'flex' });
    return {
        container,
        priceStyle,
        taxStyle,
    };
};
exports.default = useTotalPriceStyle;
